/**
 * Veículo 0km na tela (at-81).
 *
 * O backend guarda o 0km com a identificação provisória `0KM-<chassi>` no lugar da
 * placa (`saac-backend/src/carro/zero-km.util.ts`). A tela não deve exibi-la como se
 * fosse placa: um "0KM-9BWZZZ377VT004251" na lista se lê como placa estranha, não
 * como "este veículo ainda não foi emplacado".
 *
 * ⚠️ A regra de QUANDO é 0km vem do backend (`zeroKm` na resposta da carteira); o
 * prefixo é conferido aqui só para os lugares que recebem apenas a placa.
 */

const PREFIXO = '0KM-';

export const ROTULO_SEM_PLACA = '0km (sem placa)';

export function ehPlacaZeroKm(placa: string | null | undefined): boolean {
  return String(placa ?? '').toUpperCase().startsWith(PREFIXO);
}

/** A placa para exibir — a identificação provisória vira texto legível. */
export function rotuloPlaca(placa: string | null | undefined): string {
  return ehPlacaZeroKm(placa) ? ROTULO_SEM_PLACA : String(placa ?? '');
}
